<template>
  <div class="subContainer">
    <div class="row mb5">
      <div class="col-md-6">
        <div class="form-group">
          <v-select
            :options="companyList"
            :placeholder="'Select Company'"
            :label="'companyname'"
            v-model="selComp"
            @input="getCompRawData"
          >
            <!-- <div class="spinner" v-show="spinner">Loading...</div> -->
          </v-select>
        </div>
      </div>
      <div class="col-md-3"></div>
      <div class="col-md-3">
        <a class="btn btn-sm btn-small btn-success" @click.prevent="showDetailView(company)">
          <i :title="'View Details'" class="fa fa-eye cwhite"></i>
        </a>
        <a class="btn btn-sm btn-small btn-warning" @click.prevent="viewCalculatedData(company)">
          <i :title="'Calculated Data'" class="fa fa-calculator cwhite"></i>
        </a>
        <router-link class="btn btn-sm btn-small btn-info" to="/rawdata">
          <i :title="'Raw Data'" class="fa fa-list cwhite"></i>
        </router-link>
        <router-link class="btn btn-sm btn-small btn-dark" to="/company-prices-graph">
          <i :title="'Company Price Graph'" class="fa fa-line-chart cwhite"></i>
        </router-link>
        <router-link class="btn btn-sm btn-small btn-danger" to="/company-price-analysis">
          <i :title="'Price Analysis'" class="fa fa-money cwhite"></i>
        </router-link>        
        <router-link class="btn btn-sm btn-small btn-secondary" :to="{name: 'pTrends', props: { isIndividual: 0 } }">
          <i :title="'P Trends'" class="fa fa-area-chart cwhite"></i>
        </router-link>
      </div>
    </div>
    <div class="row mb5" v-if="selComp!==''">
      <div class="col-md-12">
        <vue-tabs v-model="selCompTab" direction="horizontal" @tab-change="getTabData">
          <v-tab title="General">
            <companyGeneralData :companyData="rawData" :selCompany="company" :isFromComp="isFrom"></companyGeneralData>
          </v-tab>
          <v-tab title="Macro">
            <editCompany :companyData="rawData" :selCompany="company" :isFromComp="isFrom"></editCompany>
          </v-tab>
          <v-tab title="Projected Data">
            <projectedData :companyData="rawData" :selCompany="company" :isFromComp="isFrom"></projectedData>
          </v-tab>
          <v-tab title="Projected Data Growth1">
            <projectedDataGrowth1 :companyData="rawData" :selCompany="company" :isFromComp="isFrom"></projectedDataGrowth1>
          </v-tab>
          <!-- <v-tab title="Benchmark">
            <benchmark :companyData="rawData" :selCompany="company" :isFromComp="isFrom"></benchmark>
          </v-tab>-->
        </vue-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import editCompany from "../company/editCompany";
import companyGeneralData from "@/views/manual-forms/company-general-data";
import projectedData from "@/views/manual-forms/projected-data";
import projectedDataGrowth1 from "@/views/manual-forms/projected-data-growth1";
import benchmark from "@/views/manual-forms/benchmark";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: { companyGeneralData, editCompany, projectedData, projectedDataGrowth1, benchmark },
  mixins: [commonMixins],
  created() {
    this.getCompaniesList();
  },
  data() {
    return {
      companyList: [],
      selComp: "",
      company: { co_code: "", companyname: "" },
      rawDataApi: "companyWisePriceAnalysis",
      rawData: {},
      isFrom: 2,
      selCompTab: ""
    };
  },
  methods: {
    getRawData() {
      http.get(
        "getUpdatedCompnayWiseData/" + this.company.co_code,
        {},
        (error, response) => {
          console.log("getUpdatedCompnayWiseData", response);
          if (response.length > 0) {
            this.rawData = response[0];
          } else {
            this.rawData = this.company;
          }
        }
      );
    },
    getCompanies() {
      var companies = [];
      this.rawData.balance_sheet.forEach(function(val, index) {
        if (val.coname && val.coname !== null)
          companies.push({ id: val.coname, value: val.coname });
      });
      this.companies = companies;
    },
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
          if (localStorage.getItem("selcomp") === null) {
            _this.selComp = _this.companyList[0];
            localStorage.setItem("selcomp", JSON.stringify(_this.selComp));
          } else {
            _this.selComp = JSON.parse(localStorage.getItem("selcomp"));
          }
          _this.company.companyname = _this.selComp.companyname;
          _this.company.co_code = _this.selComp.co_code;
          // _this.$route.query.id = _this.company.co_code;
        }
      });
    },
    getCompRawData() {
      console.log("Get RawData", this.selComp);
      if (this.selComp !== "") {
        localStorage.setItem("selcomp", JSON.stringify(this.selComp));
        this.company.companyname = this.selComp.companyname;
        this.company.co_code = this.selComp.co_code;
        // this.$route.query.id = this.company.co_code;
        console.log(
          "Company",
          this.company.co_code,
          "=>",
          this.company.companyname
        );
        // this.getTabData(this.selRowInd, {}, {});
        this.getRawData();
      }
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log("TabChange", tabIndex, newTab, oldTab);
      this.selCompTab = tabIndex;
      localStorage.setItem("compFormTab", this.selCompTab);
    }
  },
  watch: {
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/company-edit.vue